import { FC, ReactElement, useEffect, useState, useRef, MutableRefObject, HTMLAttributes, FormEvent } from "react";
import CardContent from "@mui/material/CardContent";
import { Card, CardHeader } from "../Form.Status/Status.styled";
import CloseIcon from "../../assets/CloseIcon.svg";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { Table } from "../MoveOutTerminationTabs/MoveOut.styled";
import { CardContainer, Label2, SavedCards } from "../MoveOutTerminationTabs/MoveOut.styled";
import visa from "../../assets/visa.svg";
import CC from "../../assets/card2.svg";
import amex from "../../assets/amex.svg";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import General from '../../stores/GeneralStore'

import { Frames, CardNumber, ExpiryDate, Cvv } from 'frames-react';

import CardsStore from "../../stores/CardsStore";
import { observer } from "mobx-react";
import { Spinner, SpinnerRaw } from "../spinner.component";
import { useNavigate } from "react-router-dom";
interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  onClose?: React.MouseEventHandler<HTMLImageElement>;
  saveAccounts: (data: any) => void;
  saveAccLoader?: Boolean;
}

const Accounts: FC<Props> = ({
  onClose,
  saveAccounts,
  saveAccLoader
}: Props): ReactElement => {

  const [pageLoader, setPageLoader] = useState(true);
  const handleGetAccountsList = async () => {
    const res = await CardsStore.getAccountsList({ errorId: 'getAccountsListError' })
    if (res?.message == "Success") {
      setPageLoader(false);
    }
  }


  const [selectedRows, setSelectedRows] = useState<any>([]);

  const handleCheckboxChange = (accountId: any) => {
    if (selectedRows.some((row: any) => row.accountId === accountId)) {
      // If the row is already selected, remove it from the array
      setSelectedRows(selectedRows.filter((row: any) => row.accountId !== accountId));
    } else {
      // If the row is not selected, add it to the array
      const account = { accountId };
      setSelectedRows([...selectedRows, account]);
    }
  };

  const handleInputChange = (e: any, accountId: any) => {
    const updatedRows = selectedRows.map((row: any) => {
      if (row.accountId === accountId) {
        return { ...row, paymentDate: e.target.value };
      }
      return row;
    });
    setSelectedRows(updatedRows);
  };

  const handleSave = () => {
    saveAccounts(selectedRows);
  }
  const navigate = useNavigate()
  useEffect(() => {
    handleGetAccountsList()
    navigate("/dashboard", { state: null });
  }, [])

  return (

    <Card style={{
      overflow: 'auto',
      margin: "auto",
      width: General?.isLargeScreen ? "63vw" : "100%",
      height: "auto",
      color: '#101e8e', display: "flex",
      backgroundColor: "white",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "30px"
    }}>
      {onClose
        ? <CardHeader
          style={{
            width: "100%",
            height: "10vh",
            display: "flex",
            background: General.contrast.contrastBackground
              ? General.contrast.contrastBackground
              : General?.ColorAss
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", width: "95%" }}>


            <h1
              style={{
                color: General.contrast.contrastColor
                  ? General.contrast.contrastColor
                  : '#fff',
                justifySelf: "flex-start",
                fontSize: `${2 * General.accessibility.fontSize}rem`
              }}>
              {General?.codeLabels["cm_add_new_acct"]?.label !== undefined ? General?.codeLabels["cm_add_new_acct"]?.label : "Add New Account"}
            </h1>
            <img src={CloseIcon} alt="" onClick={onClose} />
          </div>
        </CardHeader >
        : null}

      <CardContent sx={{
        background: General.contrast.contrastColor
          ? General.contrast.contrastColor
          : "#fff",
        color: General.contrast.contrastBackground
          ? General.contrast.contrastBackground
          : General?.ColorAss,
        width: '100%',
        maxHeight: "45vh",
        overflow: 'auto',
        scrollBehavior: 'auto'
      }}>

        {pageLoader ? <Spinner /> : CardsStore.accountsList.length > 0 ?
          <Table
            lastChild={true}
          >
            <thead
              >
              <tr style={{
                background: General.contrast.contrastBackground
                  ? General.contrast.contrastBackground
                  : '',
                color: General.contrast.contrastColor
                  ? General.contrast.contrastColor
                  : General?.ColorAss,
                  opacity: 1
              }}>
                <th className={General?.textClass} style={{ fontSize: `${General.accessibility.fontSize}rem` }}><input type={'checkbox'}></input></th>
                <th className={General?.textClass} style={{ fontSize: `${General.accessibility.fontSize}rem` }}>{General?.codeLabels["cm_accountnopaymentstable"]?.label !== undefined ? General?.codeLabels["cm_accountnopaymentstable"]?.label : "Account Number"}</th>
                <th className={General?.textClass} style={{ fontSize: `${General.accessibility.fontSize}rem` }}>{General?.codeLabels["cm_noccustomername"]?.label !== undefined ? General?.codeLabels["cm_noccustomername"]?.label : "Customer Name"}</th>
                <th className={General?.textClass} style={{ fontSize: `${General.accessibility.fontSize}rem` }}>{General?.codeLabels["cm_paymentdatedatatable"]?.label !== undefined ? General?.codeLabels["cm_paymentdatedatatable"]?.label : "Payment Date"}</th>
              </tr >
            </thead >
            <tbody>
              {
                CardsStore.accountsList.map((account: Obj) => {

                  return <tr style={{
                    background: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : "#fff",
                    color: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : General?.ColorAss,
                  }}>
                    <th className={General?.textClass} style={{ fontSize: `${General.accessibility.fontSize}rem` }}><input onChange={() => handleCheckboxChange(account.accountId)} type={'checkbox'}></input></th>
                    <td className={General?.textClass} style={{ fontSize: `${General.accessibility.fontSize}rem` }}>{account.accountId}</td>
                    <td className={General?.textClass} style={{ fontSize: `${General.accessibility.fontSize}rem` }}>{account.customerName}</td>
                    <td className={General?.textClass} style={{ fontSize: `${General.accessibility.fontSize}rem` }}>
                      <select
                        className={General?.textClass}
                        style={{
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : General?.ColorAss,
                          background: General.contrast.contrastBackground
                            ? General.contrast.contrastBackground
                            : '',
                          fontSize: `${General.accessibility.fontSize}rem`,
                          width: General?.isLargeScreen?'50%':'100%',
                        }}
                        // ref={genderValue}
                        onChange={(e) => handleInputChange(e, account.accountId)}
                        disabled={!selectedRows.some((row: any) => row.accountId === account.accountId)}
                      >
                        <option disabled selected>
                          {General?.codeLabels['cm_pdc_select']?.label ? General?.codeLabels['cm_pdc_select']?.label : "Select"}
                        </option>
                        {
                          [...Array(28).keys()].map((num: any) =>
                            <option key={num + 1}
                              value={num + 1}>
                              {num + 1}
                            </option>
                          )
                        }


                      </select>
                    </td>
                  </tr>
                })
              }

            </tbody>
          </Table > : <>{General?.codeLabels["cm_nomore_acct"]?.label ? General?.codeLabels["cm_nomore_acct"]?.label : "No more accounts to add"}

          </>
        }



        {CardsStore.accountsList.length > 0 && <ButtonsContainer style={{ justifyContent: 'end', width: '100%', height: "10vh", display: "flex", alignItems: "center" }}>

          <ButtonSecondary
            style={{
              width: "12rem",
              padding: "auto",
              color: General.contrast.contrastColor
                ? General.contrast.contrastColor
                : '#fff',
              background: General.contrast.contrastBackground
                ? General.contrast.contrastBackground
                : General?.ColorAss,
              fontWeight: 'bold',
              border: 'none',
              fontSize: `${General.accessibility.fontSize}rem`
            }}
            onClick={handleSave}
          //className={General?.colorClass}
          >
            {saveAccLoader ? <SpinnerRaw width={30} height={30} /> : General?.codeLabels["cm_save"]?.label ? General?.codeLabels["cm_save"]?.label : "save"}
          </ButtonSecondary>
        </ButtonsContainer>}
      </CardContent >
    </Card >
  );
};

export default observer(Accounts);
